// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module__list___17olp","item":"styles-module__item___1APb4"};